import { z } from "zod";
export function defineEvent(definition) {
    return definition;
}
/** Outbox'tan kuyruklara ve Redis pub/sub'a taşınan zarf. */
export const eventEnvelopeSchema = z.object({
    id: z.uuid(),
    seq: z.string().describe("Outbox sıra numarası (bigint, dizge)"),
    tenantId: z.uuid().nullable(),
    aggregateType: z.string(),
    aggregateId: z.uuid(),
    type: z.string(),
    version: z.number().int().positive(),
    payload: z.record(z.string(), z.unknown()),
    metadata: z
        .object({
        stationId: z.uuid().optional(),
        targetUserId: z.uuid().optional(),
        actorUserId: z.uuid().optional(),
        requestId: z.string().optional(),
    })
        .loose(),
    occurredAt: z.iso.datetime({ offset: true }),
});
//# sourceMappingURL=registry.js.map